module.exports = __webpack_public_path__ + "media/images/faire_32x32-ab8e8f6523da6a100413374bdd0b7cd5.png";